import { InvalidRouterInitParamsError } from './errors/invalid-router-init-params.error';
// some actual JavaScript is needed so this file gets picked up in compilation lol
export function createRouteInitParams(routeBase, routeSanitizer, maxListenerCount) {
    const routerInitParams = {
        routeBase,
        maxListenerCount,
        routeSanitizer,
    };
    return routerInitParams;
}
export function assertValidRouteInitParams(input) {
    if ('routeBase' in input &&
        typeof input.routeBase !== 'string' &&
        input.routeBase != undefined) {
        throw new InvalidRouterInitParamsError(`Invalid type for router init params "routeBase" property. Expected string or undefined but got "${input.routeBase}" with type "${typeof input.routeBase}".`);
    }
    if ('routeSanitizer' in input &&
        typeof input.routeSanitizer !== 'function' &&
        input.routeSanitizer != undefined) {
        throw new InvalidRouterInitParamsError(`Invalid type for router init params "routeSanitizer" property. Expected a function or undefined but got "${input.routeSanitizer}" with type "${typeof input.routeSanitizer}".`);
    }
    if ('maxListenerCount' in input &&
        (typeof input.maxListenerCount !== 'number' || isNaN(input.maxListenerCount)) &&
        input.maxListenerCount != undefined) {
        throw new InvalidRouterInitParamsError(`Invalid type for router init params "maxListenerCount" property. Expected a number or undefined but got "${input.maxListenerCount}" with type "${typeof input.maxListenerCount}".`);
    }
}
